export default __webpack_public_path__ + "static/media/spaces_in_sharjah_256.fcb32c8f.jpg";